var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.16602C14.9399 7.16602 15.1666 6.93935 15.1666 6.66602V5.99935C15.1666 3.05935 14.2733 2.16602 11.3333 2.16602H7.16659V3.66602C7.16659 3.93935 6.93992 4.16602 6.66659 4.16602C6.39325 4.16602 6.16659 3.93935 6.16659 3.66602V2.16602H4.66659C1.72659 2.16602 0.833252 3.05935 0.833252 5.99935V6.33268C0.833252 6.60602 1.05992 6.83268 1.33325 6.83268C1.97325 6.83268 2.49992 7.35935 2.49992 7.99935C2.49992 8.63935 1.97325 9.16602 1.33325 9.16602C1.05992 9.16602 0.833252 9.39268 0.833252 9.66602V9.99935C0.833252 12.9393 1.72659 13.8327 4.66659 13.8327H6.16659V12.3327C6.16659 12.0593 6.39325 11.8327 6.66659 11.8327C6.93992 11.8327 7.16659 12.0593 7.16659 12.3327V13.8327H11.3333C14.2733 13.8327 15.1666 12.9393 15.1666 9.99935C15.1666 9.72602 14.9399 9.49935 14.6666 9.49935C14.0266 9.49935 13.4999 8.97268 13.4999 8.33268C13.4999 7.69268 14.0266 7.16602 14.6666 7.16602ZM7.16659 9.44602C7.16659 9.71935 6.93992 9.94602 6.66659 9.94602C6.39325 9.94602 6.16659 9.71935 6.16659 9.44602V6.55268C6.16659 6.27935 6.39325 6.05268 6.66659 6.05268C6.93992 6.05268 7.16659 6.27935 7.16659 6.55268V9.44602Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.c6944ec35110b2ea7fd7ba53e7d8bb3f.svg";
export { ForwardRef as ReactComponent };